// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg.iconify[data-v-6dfef1fb]{-webkit-animation:fade-in .25s ease-out;animation:fade-in .25s ease-out}", ""]);
// Exports
module.exports = exports;
